import React, { useEffect } from 'react';
import { styled } from '@mui/system';
import Icon from '@mui/material/Icon';
import WebFont from 'webfontloader';
import Text from '../Text.js';
import { colors } from '../../theme/index.js';

/**
 *
 * @param {*} str
 * @returns
 */
const camelToSnakeCase = str => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

/**
 *
 * @param {*} param0
 */
const HorizonalTile = ({
  onClick,
  title,
  description,
  icon,
  isSelected = false,
  disabled,
  classes,
  customStyle,
  id,
  testid
}) => {
  useEffect(() => {
    WebFont.load({
      google: {
        families: ['Material Icons']
      }
    });
  }, []);

  /**
   * 
   * @returns 
   */
  function setDisabled() {
    if (disabled) {
      const disabledStyle = {
        boxShadow: 'none',
        '&:hover': {
          boxShadow: 'none'
        }
      };
      return disabledStyle;
    }
    return null;
  }
  const ContainerDiv = styled('div')(() => ({
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.15)',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: "24px 32px",
    cursor: 'pointer',
    position: 'relative',
    '&:hover': {
      boxShadow: '0px 12px 40px rgba(0, 0, 0, 0.15)'
    },
    zIndex: 2,
    background: isSelected ? colors.lightBlue : colors.surface,
    border: isSelected ? `5px ${colors.gradientBlue} solid` : 'none',
    ...setDisabled(),
    ...customStyle
  }));
  const styles = {
    iconContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 0.5
    },
    textContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      flex: 5,
      padding: '0 20px',
      width: '100%'
    },
    icon: {
      color: icon.color || '#000',
      fontSize: 30
    }
  };
  return /*#__PURE__*/React.createElement(ContainerDiv, {
    id: id || testid,
    onClick: disabled || !onClick ? null : onClick
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'start',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.iconContainer
  }, /*#__PURE__*/React.createElement(Icon, {
    style: styles.icon
  }, camelToSnakeCase(icon.name))), /*#__PURE__*/React.createElement("div", {
    style: styles.textContainer
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true
    // Todo: tile color
    ,
    color: isSelected ? colors.darkBlue : colors.darkGrey,
    display: "block",
    align: "left"
  }, title), /*#__PURE__*/React.createElement(Text, {
    small: true,
    light: true,
    display: "block",
    align: "left",
    margin: "10px 0 0 0",
    color: isSelected ? colors.darkBlue : colors.darkGrey,
    customStyle: {
      width: "100%",
      wordBreak: "break-word"
    }
  }, description))));
};
export default HorizonalTile;